<template>
  <div class="min-h-screen bg-gray-50">
    <div class="max-w-7xl mx-auto  sm:px-6 lg:px-8">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
:root {
  --primary-color: #2563EB;
  --primary-hover: #1D4ED8;
  --primary-light: #DBEAFE;
  --tech-blue: #1E40AF;
  --tech-blue-light: #3B82F6;
  --tech-blue-dark: #1E3A8A;
}

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer components {
  .btn-primary {
    @apply bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200;
  }
  
  .card {
    @apply bg-white rounded-lg shadow-md p-6;
  }
  
  .input-field {
    @apply w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none;
  }
  
  .tech-gradient {
    background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);
  }
  
  .tech-shadow {
    box-shadow: 0 4px 20px rgba(30, 64, 175, 0.15);
  }
}
</style>
